import { combineReducers } from "redux";

import listView, { ListViewActions } from "./listView/reducer";
import { MoveStopsActions } from "./moveStops/actions";
import moveStops from "./moveStops/reducer";
import routeDetails, { RouteDetailsActions } from "./routeDetails";
import upcomingView, { UpcomingViewActions } from "./upcomingView/reducer";

const route = combineReducers({
  listView,
  moveStops,
  routeDetails,
  upcomingView,
});

export interface RouteState {
  listView: ReturnType<typeof listView>;
  moveStops: ReturnType<typeof moveStops>;
  routeDetails: ReturnType<typeof routeDetails>;
  upcomingView: ReturnType<typeof upcomingView>;
}

export * from "./listView/selectors";
export * from "./moveStops/selectors";
export * from "./routeDetails/selectors";
export * from "./upcomingView/selectors";

export type RouteActions =
  | ListViewActions
  | MoveStopsActions
  | RouteDetailsActions
  | UpcomingViewActions;
export default route;
